import React from "react";
import StrategicLeadershipServices from "./components/StrategicLeadershipServices";
import Projects from "./components/Projects";

export default function Services() {
  return (
    <>
      <StrategicLeadershipServices />
      <Projects />
    </>
  );
}
